import { Occupation } from '@map/types';
import { remoteDataChanged, useRemoteData } from './baseApi';
import { OccupationMatch } from './occupationsApi';

type OccupationGroup = {
  id: number;
  title: string;
  occupations?: Occupation[];
  result_type?: any;
};

type OccupationGroupSuggestion = Omit<OccupationGroup, 'occupations'> & {
  occupations: OccupationMatch[];
};

const url = 'occupation_suggestions';

export const suggestedOccupationGroupsChanged = () => remoteDataChanged(url);
export const useSuggestedOccupationGroups = () => {
  const [data = []] = useRemoteData<OccupationGroupSuggestion[]>({ url });
  return [data] as const;
};

export const useSuggestedOccupationGroupsForCareersReport = (categoriesId: number[]) => {
  const [data = []] = useRemoteData<OccupationGroupSuggestion[]>({
    url: `${url}/for_careers_report?categories=${categoriesId.join()}`,
  });
  return data;
};
